import React from "react";

const Option = ({ children, value, disabled, ariaLabelledby, ...props }) => {
  return (
    <option
      value={value}
      disabled={disabled}
      aria-labelledby={ariaLabelledby || children}
      {...props}
    >
      {children}
    </option>
  );
};

export const Options = ({ list }) => {
  return list?.map((item) => (
    <Option key={item.value} value={item.value} {...item}>
      {item.text || item.label}
    </Option>
  ));
};

export default Option;
